.resourcePage {
  width: 100%;
  min-width: 0;
}

.resourcePageHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5rem;
  row-gap: 0.5rem;
  width: 100%;
  margin-bottom: 2rem;
}

.resourceTitleGroup {
  margin-bottom: var(--space-4);
  flex-shrink: 0;
}

.resourcePageTitle {
  margin: 0;
  font-family: var(--font-family-heading);
  font-size: var(--font-size-2xl);
  color: var(--color-text);
  line-height: 1.05;
  letter-spacing: 0.02em;
}

.resourceCount {
  margin: var(--space-4) 0 0;
  font-size: var(--font-size-lg);
  color: var(--color-text);
}

.resourcePageHeaderFilters {
  width: 100%;
}

.resourcePageGroups {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  min-width: 0;
}

.resourcePageTilesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1450px;
}


@media (max-width: 768px) {
  .resourcePageHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .resourcePageTitle {
    font-size: 18px;
    text-align: center;
  }

  .resourcePageTitle::after {
    left: 10%;
    width: 80%;
  }

  .resourcePageTilesGrid {
    grid-template-columns: 1fr;
  }
}
